export default {
    ADD_REPORT_LIST: "setCompareReportList",
    ADD_COMPARE_ITEMS: "setCompareItems",
    ADD_PREVIEW_ORDER: "setPreviewOrder",
    ADD_RESET: "setCompareReset"
}
